module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-11.e9b2a637.png";